import { useEffect } from 'react';
import { useFallbackLocationQuery } from 'lib/react-query/Queries/useFallbackLocationQuery';
import { TLocation } from 'lib/types/location';
import { useAppDispatch } from 'state/hooks';
import { setLocation } from 'state/slices/location';
import { getLocationFromTimezone } from 'lib/helper/timezone/timezone';
import * as Sentry from '@sentry/react';
import { sessionIdService } from 'services/session-id/session-id.service';

const useSetLocation = () => {
  const { isLoading, data, error } = useFallbackLocationQuery();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isLoading) return;

    let location: TLocation;

    if (error || !data || !data.country) {
      // Fallback to timezone-based detection
      location = getLocationFromTimezone();

      Sentry.addBreadcrumb({
        category: 'location',
        message: 'Using timezone fallback due to geoip failure',
        level: 'info',
        data: {
          fallback_type: 'timezone',
          user_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          session_id: sessionIdService.get(),
        },
      });
    } else {
      // Use geoip data
      location = {
        continent: data.continent.name,
        region: data.region.name,
        country: {
          code: data.country.code,
          name: data.country.name,
        },
      };
    }

    dispatch(setLocation(location));
  }, [data, dispatch, isLoading, error]);
};

export { useSetLocation };
